import { Grid as Mui4Grid, GridProps as Mui4GridPropsType } from '@material-ui/core'
import { default as Mui5Grid, GridProps as Mui5GridPropsType } from '@mui/material/Grid'
import { forwardRef } from 'react'
import { useComponentVersion } from '../hooks'

export enum GridVersion {
  V1 = 1, // MUI4 + OS Theme
  V2 = 2, // MUI5 + Stratis
}

export type GridProps = Mui4GridPropsType & {
  rowSpacing?: Mui5GridPropsType['rowSpacing']
  columnSpacing?: Mui5GridPropsType['columnSpacing']
  mb?: Mui5GridPropsType['mb']
  mt?: Mui5GridPropsType['mt']
  justifyContent?: Mui5GridPropsType['justifyContent']
}

// * MUI Grid API Spec  https://mui.com/material-ui/api/Grid/
export const Grid = forwardRef<HTMLDivElement, GridProps>(
  ({ rowSpacing, columnSpacing, mb, mt, justifyContent, ...props }, ref) => {
    const version = useComponentVersion('grid')
    const propsVersion = (props as any).version || version

    switch (propsVersion) {
      case GridVersion.V2:
        return (
          <Mui5Grid
            ref={ref}
            {...props}
            rowSpacing={rowSpacing}
            columnSpacing={columnSpacing}
            mb={mb}
            mt={mt}
            justifyContent={justifyContent}
          />
        )

      default:
        return <Mui4Grid ref={ref} {...props} />
    }
  }
)
